var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "experience-item" }, [
    _c("div", { staticClass: "experience-image" }, [
      _c("div", { staticClass: "slide-image" }, [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: {
                  src: _vm.experience.experienceImage,
                  variant: "experience-list",
                },
                expression:
                  "{ src: experience.experienceImage,\n                  variant: 'experience-list' }",
              },
            ],
            key: "experience-" + _vm.experience.id + ".-image",
            staticClass: "image-wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                alt: _vm.experience.altImg,
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.experience.isFansOfMOExclusive
          ? _c("div", { staticClass: "experience-label fan-exclusive" }, [
              _vm._v(_vm._s(_vm.dictionary.fansExclusive)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showLabel
          ? _c("div", { staticClass: "experience-label" }, [
              _vm._v(_vm._s(_vm.experience.label)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.experience.isFansOfMOEliteExclusive
          ? _c("div", { staticClass: "experience-label elite-fan-exclusive" }, [
              _vm._v(_vm._s(_vm.dictionary.fansEliteExclusive)),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "experience-content" }, [
      _c("div", { staticClass: "experience-eyebrow" }, [
        _vm._v(_vm._s(_vm.eyebrowData)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "experience-title" }, [
        _vm._v(_vm._s(_vm.experience.experienceTitle)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "experience-description",
        domProps: { innerHTML: _vm._s(_vm.experience.shortDescription) },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "experience-utility" }, [
      _c("div", { staticClass: "experience-ctas" }, [
        _vm.experience.secondaryCtaUrl
          ? _c(
              "a",
              {
                staticClass: "experience-cta-secondary",
                attrs: {
                  href: _vm.experience.secondaryCtaUrl,
                  target: _vm.experience.secondaryCtaTarget,
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.experience.secondaryCtaLabel ||
                        _vm.dictionary.purchase
                    ) +
                    "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "experience-cta-primary",
            attrs: { href: _vm.experience.url },
          },
          [_vm._v(_vm._s(_vm.dictionary.seeDetails))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }